module.exports = __webpack_public_path__ + "img/icon-close.0d2724b4.svg";